<div class="cardTable-container">
  <mat-label class="{{ componentDefinition.mandatory ? 'mandatory' : '' }} ">{{ componentDefinition.label }} </mat-label>
  <ng-container *ngIf="loading">Loading Data...</ng-container>
  <mat-accordion multi class="cardTable-board" *ngIf="!loading">
    <mat-expansion-panel
      class="cardTable-groups"
      [style.height]="height"
      *ngFor="let group of groups; let g = index"
      [expanded]="true"
      [hideToggle]="group.collapsible == false"
    >
      <mat-expansion-panel-header [ngClass]="{ 'always-expand': group.collapsible == false }">
        <h3>{{ group.grpHeader }}</h3>
      </mat-expansion-panel-header>
      <mat-accordion multi class="cardTable-lists" cdkDropListGroup>
        <mat-expansion-panel
          cdkDropList
          [cdkDropListData]="column.docs"
          class="cardTable-list"
          *ngFor="let column of group.columns; let c = index"
          (cdkDropListDropped)="dropCard($event, column, group)"
          [expanded]="true"
          [id]="column.colId"
          [cdkDropListConnectedTo]="column.connectedLists"
          [hideToggle]="column.collapsible == false"
        >
          <mat-expansion-panel-header [ngClass]="{ 'always-expand': column.collapsible == false }">
            <h3>{{ column.colHeader }}</h3>
          </mat-expansion-panel-header>
          <mat-card
            *ngFor="let card of column.docs"
            (mousedown)="onDragStarted(card)"
            (mouseup)="clearDragTimeout()"
             cdkDrag
            class="cardTable-card"
            [class.dragging]="currentDragId === card.documentId && dragDelayElapsed"
            [cdkDragStartDelay]="delayedDragging"
            [cdkDragData]="card"
            [ngStyle]="{ 'min-width.px': this.minCardWidth }"
          >
            <mat-card-content>
              <div [innerHTML]="displayCard(card)"></div>
            </mat-card-content>
            <mat-card-footer *ngIf="card.rankingField" class="footer">
              <ng-container *ngIf="editingCardId === card.documentId; else viewMode" class="rank-container">
                <form #rankingForm="ngForm">
                  <mat-form-field class="rank-form-field" appearance="outline">
                    <mat-label>Rank</mat-label>
                    <input
                      matInput
                      #rankInput
                      [value]="card.rankingField"
                      placeholder="Enter a new Rank"
                      class="rankInput"
                      type="number"
                      min="0"
                    />
                    <button mat-icon-button matSuffix type="button"   class="ranking-button" [disabled]="!rankInput.value" (click)="saveRankField(card,rankInput.value, column, g, c)" >
                      <mat-icon>check</mat-icon>
                    </button>
                  </mat-form-field>
                </form>
              </ng-container>
              <ng-template  #viewMode class="rank-container">
                <p>Rank: {{ card.rankingField }}</p>
                <button mat-icon-button (click)="editRankField(card.documentId)" class="ranking-button">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              </ng-template>
            </mat-card-footer>
          </mat-card>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-expansion-panel>
  </mat-accordion>
</div>
